module.exports = __webpack_public_path__ + "img/loading.6ab6741f.png";